import React, { useEffect, useState } from "react";
import {
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationItem,
    PaginationLink,
    PaginationNext,
    PaginationPrevious,
} from "../../../ui/pagination"
const PagenationOt = ({
    pageIndex = 0,
    pageCount = 0,
    onChange = () => { }
}) => {
    const [pageTotal, setPageTotal] = useState(pageCount || 0)

    const [currentIndex, setCurrentIndex] = useState(pageIndex || 0)
    const [showPageIndexRange, setShowPageIndexRange] = useState({
        start: 0,
        end: (pageCount || 0) < 5 ? pageCount - 1 : 5
    })
    const getShowPages = ({ pageTotal, showPageIndexRange }) => {
        return Array(pageTotal)
            .fill(1).filter((ele, filterIndex) => {
                return (filterIndex >= showPageIndexRange?.start) && (filterIndex <= showPageIndexRange?.end)
            })
            .map((value, index) => {
                return <PaginationItem key={index}>
                    <PaginationLink
                        isActive={currentIndex === showPageIndexRange?.start + index}
                        onClick={() => {
                            onChange(showPageIndexRange?.start + index)
                            setCurrentIndex(showPageIndexRange?.start + index)
                            setShowPageIndexRange((pre) => {
                                return {
                                    start: showPageIndexRange?.start + index - 2 >= 0 ? showPageIndexRange?.start + index - 2 : 0,
                                    end: showPageIndexRange?.start + index + 2 < pageTotal ? showPageIndexRange?.start + index + 2 : pageTotal - 1
                                }
                            })
                        }}
                    >{showPageIndexRange?.start + index + 1}</PaginationLink>
                </PaginationItem>
            })
    }

    useEffect(() => {
        setPageTotal(pageCount)
        setShowPageIndexRange((pre) => {
            return {
                start: 0,
                end: (pageCount || 0) < 5 ? pageCount - 1 : 5
            }
        })
    }, [pageCount])
    useEffect(() => {
        onChange(currentIndex)
    }, [currentIndex])
    useEffect(() => {
        setCurrentIndex(pageIndex)
    }, [pageIndex])
    return (<Pagination>
        <PaginationContent>
            <PaginationItem>
                <PaginationPrevious
                    disabled={currentIndex === 0}
                    onClick={() => {
                        if(currentIndex !== 0){
                            setCurrentIndex((pre) => {
                                let oldCurrent = pre
                                setShowPageIndexRange((preShowPageIndexRange) => {
                                    return {
                                        start: oldCurrent - 1 - 2 >= 0 ? oldCurrent - 1 - 2 : 0,
                                        end: oldCurrent - 1 + 2 < pageTotal ? oldCurrent - 1 + 2 : pageTotal - 1
                                    }
                                })
                                return pre - 1 >= 0 ? pre - 1 : 0
                            })
                        }
                    }}
                />
            </PaginationItem>
            {showPageIndexRange.start !== 0 &&
                <PaginationItem>
                    <PaginationLink
                        isActive={currentIndex === 0}
                        onClick={() => {
                            onChange(0)
                            setCurrentIndex(0)
                            setShowPageIndexRange((pre) => {
                                return {
                                    start: 0,
                                    end: 2 < pageTotal ? 2 : pageTotal - 1
                                }
                            })
                        }}
                    >{1}</PaginationLink>
                </PaginationItem>}
            {
                showPageIndexRange.start > 1 &&
                <PaginationItem>
                    <PaginationEllipsis
                        onClick={() => {
                            setCurrentIndex((pre) => {
                                return pre - 5 >= 0 ? pre - 5 : 0
                            })
                        }}

                    />
                </PaginationItem>
            }
            {
                getShowPages({
                    pageTotal: pageCount,
                    showPageIndexRange
                })
            }
            {
                showPageIndexRange.end < pageTotal - 2 &&
                <PaginationItem>
                    <PaginationEllipsis
                        onClick={() => {
                            setCurrentIndex((pre) => {
                                return pre + 5 < pageTotal ? pre + 5 : pageTotal - 1
                            })
                        }}
                    />
                </PaginationItem>
            }
            {
                (showPageIndexRange.end !== pageTotal - 1 && 5 < pageTotal - 1) &&
                <PaginationItem>
                    <PaginationLink
                        isActive={currentIndex === pageTotal - 1}
                        onClick={() => {
                            onChange(pageTotal - 1)
                            setCurrentIndex(pageTotal - 1)
                            setShowPageIndexRange((pre) => {
                                return {
                                    start: 0,
                                    end: 2 < pageTotal ? 2 : pageTotal - 1
                                }
                            })
                        }}
                    >{pageTotal}</PaginationLink>
                </PaginationItem>
            }

            <PaginationItem>
                <PaginationNext
                    disabled={currentIndex === pageTotal - 1}
                    onClick={() => {
                        if (!(currentIndex === pageTotal - 1)) {
                            setCurrentIndex((pre) => {
                                let oldCurrent = pre
                                setShowPageIndexRange((preShowPageIndexRange) => {
                                    return {
                                        start: oldCurrent + 1 - 2 >= 0 ? oldCurrent + 1 - 2 : 0,
                                        end: oldCurrent + 1 + 2 < pageTotal ? oldCurrent + 1 + 2 : pageTotal - 1
                                    }
                                })
                                return pre + 1 < pageTotal ? pre + 1 : pageTotal - 1

                            })
                        }
                    }}

                />
            </PaginationItem>
        </PaginationContent>
    </Pagination>)
}
export default PagenationOt

